import React from 'react';
import './ContactCTA.css';

const ContactCTA: React.FC = () => {
  return (
    <section id="contact" className="contact-cta-section">
      <div className="contact-cta-container">
        {/* Left - Map */}
        <div className="contact-cta-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d320.8508160276246!2d28.65357297708783!3d41.0156394159448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b55f724c79509d%3A0xdb4abdd7a1501f3d!2sMevlana%2C%20Hasan%20Kerim%20Cd.%20No%3A1%2C%2034515%20Esenyurt%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1770034123399!5m2!1str!2str"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Okulumuzun Konumu"
          />
        </div>

        {/* Right - CTA Content */}
        <div className="contact-cta-content">
          <h2 className="contact-cta-title">Hemen İletişime Geçin</h2>
          <p className="contact-cta-subtitle">
            Çocuğunuzun geleceği için ilk adımı atın. Okulumuz hakkında bilgi almak veya randevu oluşturmak için bizi arayın.
          </p>

          <div className="contact-cta-info">
            <div className="contact-cta-item">
              <div className="contact-cta-icon">
                <lord-icon
                  src="https://cdn.lordicon.com/srsgifqc.json"
                  trigger="hover"
                  colors="primary:#ffffff,secondary:#ffffff"
                  style={{ width: '42px', height: '42px' }}
                />
              </div>
              <div className="contact-cta-details">
                <span className="contact-cta-label">Telefon</span>
                <a href="tel:05389466443" className="contact-cta-value">0538 946 64 43</a>
              </div>
            </div>

            <div className="contact-cta-item">
              <div className="contact-cta-icon">
                <lord-icon
                  src="https://cdn.lordicon.com/surcxhka.json"
                  trigger="hover"
                  colors="primary:#ffffff,secondary:#ffffff"
                  style={{ width: '42px', height: '42px' }}
                />
              </div>
              <div className="contact-cta-details">
                <span className="contact-cta-label">Adres</span>
                <a href="https://maps.app.goo.gl/gnzFmE2588jG9vYU7" target="_blank" rel="noopener noreferrer" className="contact-cta-value">Mevlana Mah. Hasan Kerim Cad. No:1 Esenyurt/İstanbul</a>
              </div>
            </div>

            <div className="contact-cta-item">
              <div className="contact-cta-icon">
                <lord-icon
                  src="https://cdn.lordicon.com/kbtmbyzy.json"
                  trigger="hover"
                  colors="primary:#ffffff,secondary:#ffffff"
                  style={{ width: '42px', height: '42px' }}
                />
              </div>
              <div className="contact-cta-details">
                <span className="contact-cta-label">Çalışma Saatleri</span>
                <span className="contact-cta-value">Pazartesi - Cuma: 08:00 - 17:00</span>
              </div>
            </div>
          </div>

          <a href="tel:05389466443" className="contact-cta-button">
            <lord-icon
              src="https://cdn.lordicon.com/srsgifqc.json"
              trigger="hover"
              colors="primary:#ffffff,secondary:#ffffff"
              style={{ width: '28px', height: '28px' }}
            />
            <span>Hemen Randevu Al</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
